import {Component, ChangeDetectionStrategy, ViewChild} from '@angular/core';
import {IDoesFilterPassParams, IFilterParams} from 'ag-grid-community';
import {IFilterAngularComp} from 'ag-grid-angular';
import {SelectItem} from 'primeng/api';
import {Listbox} from 'primeng/listbox';

@Component({ standalone: false,
  selector: 'dux-irb-ag-set-column-filter',
  templateUrl: './irb-ag-set-filter.component.html',
  styleUrls: ['./irb-ag-set-filter.component.scss']
})

export class IrbAgSetColumnFilterComponent implements IFilterAngularComp {
  inputvalues: SelectItem[] = [];
  selectedvalues: string[] = [];
  isFilterActiveReturn: boolean = false;
  multiple: boolean = true;
  checkbox: boolean = true;
  filter: boolean = true;
  @ViewChild('setFilterListbox') myListboxComponent: Listbox;
  private params: any;
  private model: any;
  isVisible: boolean = false;

  agInit(params: IFilterParams): void {
    this.params = params;
    this.isFilterActiveReturn = false;
    if (params.column.getColDef().filterParams.multiple) {
      this.multiple = params.column.getColDef().filterParams.multiple;
    }
    if (params.column.getColDef().filterParams.checkbox) {
      this.checkbox = params.column.getColDef().filterParams.checkbox;
    }
    if (params.column.getColDef().filterParams.filter) {
      this.filter = params.column.getColDef().filterParams.filter;
    }
  }

  afterGuiAttached() {
    this.isVisible = true;
  }

  afterGuiDetached() {    
      this.isVisible = false;
  }

  isFilterActive(): boolean {
    return this.isFilterActiveReturn;
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    if (params) {
    }
    return true;
  }

  getModelAsString(): any {
    return this.isFilterActive() ? this.selectedvalues.toString() : null;
  }

  getModel(): any {
    if (this.isFilterActiveReturn) {
      return {values: this.selectedvalues};
    } else {
      return null;
    }
  }

  setModel(model: any): void {
    if (model === null) {
      this.selectedvalues = [];
    } else {
      this.model = model;
      for (let i = 0; i < model.values.length; i++) {
        this.inputvalues.push({label: model.values[i], value: model.values[i]});
        this.selectedvalues.push(model.values[i]);
      }
    }
  }

  onApplyAction(): void {
    this.isFilterActiveReturn = true;
    this.params.filterChangedCallback();
    this.isVisible = false;
  }

  onClearAction(): void {
    this.clearAllValues();
    this.params.filterChangedCallback();
    this.isVisible = false;
  }

  clearAllValues(): void {
    this.isFilterActiveReturn = false;
    this.inputvalues = [];
    this.myListboxComponent.filterValue = '';
    this.selectedvalues = [];
    for (let i = 0; i < this.model.values.length; i++) {
      this.inputvalues.push({label: this.model.values[i], value: this.model.values[i]});
      this.selectedvalues.push(this.model.values[i]);
    }
  }

  onKeydown(event: KeyboardEvent) {
    const key = event.key;
    if (this.inputvalues.length === this.selectedvalues.length) {
      this.selectedvalues = [];
    }
  }
}
